import { markPageNavigationStart } from '@/utils/analytics/pageTiming';

export function onRouterTransitionStart(
  url: string,
  navigationType: 'push' | 'replace' | 'traverse'
): void {
  markPageNavigationStart(url, navigationType);
}
